import { CSR_EXCLUDED_SMS_CHANNELS } from './csrExcludedSmsChannels';

export interface TextCountProducerMfeData {
  apiBasePath: string;
  orgId: string;
  excludeChannels: readonly string[];
}

/**
 * The `comm-hub-text-list` payload for the count producer, built as a pure
 * function so the *presence* of a key is directly assertable
 * (`'orgIds' in data`) rather than only its value.
 *
 * The org-filter key is omitted entirely, and must stay omitted. CommHub's count
 * honours only `type`, that filter and `excludeChannels`; passing it would narrow
 * the badge, and under CCPro `orgId`'s grain is network-level while the inbox is
 * deliberately cross-org. The monolith's equivalent producer *does* pass it to
 * narrow to its tenant -- correct there and wrong here, so do not "align" the
 * two. If it is ever added, never build it from a coalesced, defaulted or
 * non-null-asserted value: CommHub answers a blank or non-member org filter with
 * an empty page and HTTP 200, a finite `0` that clears every badge and that no
 * behavioural test distinguishes from a true zero. Omitting the key errs high
 * instead of erring to zero.
 *
 * `excludeChannels`, by contrast, must always be sent and must match the Texts
 * rail's exclusions, or the badge counts unreads the list never shows.
 */
export const buildTextCountProducerMfeData = (
  apiBasePath: string,
  orgId: string,
): TextCountProducerMfeData => ({
  apiBasePath,
  orgId,
  excludeChannels: CSR_EXCLUDED_SMS_CHANNELS,
});
